import { jsx as a } from "react/jsx-runtime";
import { Ratings as l } from "../Ratings/index.js";
import n from "./Carousel.js";
import u from "./CarouselItem.js";
import { Video as c } from "../Video/index.js";
function C({
  token: t,
  reviews: m = [],
  controlsBackgroundColor: r,
  hasControls: d = !1
}) {
  return /* @__PURE__ */ a(
    n,
    {
      controls: d,
      controlsBackgroundColor: r,
      children: m == null ? void 0 : m.map((o) => /* @__PURE__ */ a(u, { children: /* @__PURE__ */ a(
        c,
        {
          id: o.id,
          token: t,
          name: o.reviewer.name,
          videoPlaybackId: o.videoPlaybackId,
          stars: /* @__PURE__ */ a(l, { rating: o.rating, size: "small" }),
          thumbFrame: o == null ? void 0 : o.thumbFrame,
          reviewSource: o == null ? void 0 : o.source
        }
      ) }))
    }
  );
}
export {
  C as VideoCardCarousel
};
